/* Crystal N Cuts — collection page helpers
   · Load more (fetches the next page of this section and appends the cards)
   · Phone Filter / Sort bar (opens Dawn's filter drawer, sorts through Dawn's form)
   · Filter bar sits under the sticky header
   · Back-to-top button
   Works alongside Dawn's facets.js; nothing here replaces it. */
(function () {
  if (window.__cncCollection) return;
  window.__cncCollection = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Load more ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cnc-next]');
    if (!btn) return;
    var root = btn.closest('[data-cnc-coll]');
    var grid = root && $('#product-grid', root);
    if (!grid || !window.fetch || !window.DOMParser) return; // fall back to a normal page link
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    var url = btn.getAttribute('href');
    var sectionId = root.getAttribute('data-section-id');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var newMore = doc.querySelector('[data-cnc-loadmore]');
        var oldMore = $('[data-cnc-loadmore]', root);
        if (!newGrid) throw new Error('no grid');
        var first = null;
        $$(':scope > li', newGrid).forEach(function (li) {
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          grid.appendChild(li);
          if (!first) first = li;
        });
        if (oldMore) {
          if (newMore) oldMore.replaceWith(newMore);
          else oldMore.remove();
        }
        // move keyboard focus to the first new product so keyboard users continue from there
        var link = first && (first.querySelector('.card__heading a[href]') || first.querySelector('a[href]'));
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = url; });
  });

  /* ---------- Phone bar ---------- */
  function syncBar(root) {
    var bar = $('[data-cnc-mbar]', root);
    if (!bar) return;
    var n = $('[data-cnc-filter-count]', bar);
    if (n) {
      var count = $$('.active-facets-mobile facet-remove:not(.active-facets__button-wrapper)', root).length;
      n.textContent = count;
      n.hidden = count === 0;
    }
    var sel = $('[data-cnc-sort]', bar);
    var label = $('[data-cnc-sort-label]', bar);
    if (sel) {
      var current = new URLSearchParams(window.location.search).get('sort_by');
      if (current) sel.value = current;
      if (label && sel.selectedIndex > -1) label.textContent = '· ' + sel.options[sel.selectedIndex].text.replace(/^Price,\s*/i, '');
    }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-cnc-open-filters]');
    if (!open) return;
    var root = open.closest('[data-cnc-coll]');
    var summary = root && $('.mobile-facets__wrapper summary', root);
    if (summary) summary.click();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-cnc-sort]');
    if (!sel) return;
    var root = sel.closest('[data-cnc-coll]');
    var dawnSort = root && $('#SortBy-mobile', root);
    if (dawnSort) {
      dawnSort.value = sel.value;
      dawnSort.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      params.delete('page');
      window.location.search = params.toString();
      return;
    }
    syncBar(root);
  });

  /* ---------- Filter bar under the sticky header ---------- */
  var headerEl = null;
  function stickyTop() {
    if (!headerEl) headerEl = document.querySelector('.section-header, .shopify-section-group-header-group');
    var top = 0;
    if (headerEl) {
      var r = headerEl.getBoundingClientRect();
      var pos = getComputedStyle(headerEl).position;
      if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0) top = Math.round(r.bottom);
    }
    $$('[data-cnc-coll]').forEach(function (root) { root.style.setProperty('--cc-sticky-top', top + 'px'); });
  }

  /* ---------- Back to top ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      stickyTop();
      var y = window.scrollY || window.pageYOffset;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      $$('[data-cnc-btt]').forEach(function (b) {
        b.classList.toggle('is-on', y > window.innerHeight * 1.5);
        var c = b.querySelector('circle');
        if (c && max > 0) c.setAttribute('stroke-dashoffset', String(100 - Math.min(100, (y / max) * 100)));
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('[data-cnc-btt]'))) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var focusTarget = document.querySelector('main h1, #MainContent');
    if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus({ preventScroll: true }); }
  });

  /* ---------- Filter dropdowns: close on outside click, Esc, Done; one open at a time ---------- */
  function closeFilters(except) {
    $$('[data-cnc-coll] details.facets__disclosure[open]').forEach(function (d) {
      if (d === except) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var done = e.target.closest('[data-cnc-close-filter]');
    if (done) {
      var d = done.closest('details');
      closeFilters();
      var s = d && d.querySelector('summary');
      if (s) s.focus({ preventScroll: true });
      return;
    }
    var summary = e.target.closest('[data-cnc-coll] details.facets__disclosure > summary');
    if (summary) { closeFilters(summary.parentNode); return; }
    if (!e.target.closest('[data-cnc-coll] details.facets__disclosure')) closeFilters();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-cnc-coll] details.facets__disclosure[open]');
    if (!open) return;
    closeFilters();
    var s = open.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
  });

  /* ---------- Shape rail: arrows + keep its scroll position when Dawn re-renders it ---------- */
  var railScroll = {};
  function railUpdate(rail) {
    var t = $('[data-cnc-rail-track]', rail);
    if (!t) return;
    var max = t.scrollWidth - t.clientWidth;
    var prev = $('[data-cnc-rail-step="-1"]', rail), next = $('[data-cnc-rail-step="1"]', rail);
    if (prev) prev.disabled = t.scrollLeft <= 2;
    if (next) next.disabled = t.scrollLeft >= max - 2;
  }
  function enhanceRails(root) {
    $$('[data-cnc-rail]', root).forEach(function (rail) {
      var t = $('[data-cnc-rail-track]', rail);
      if (!t || t.__cnc) return;
      t.__cnc = true;
      if (railScroll[rail.id]) t.scrollLeft = railScroll[rail.id];
      t.addEventListener('scroll', function () { railScroll[rail.id] = t.scrollLeft; railUpdate(rail); }, { passive: true });
      railUpdate(rail);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cnc-rail-step]');
    if (!b) return;
    e.preventDefault();
    var t = $('[data-cnc-rail-track]', b.closest('[data-cnc-rail]'));
    if (t) t.scrollBy({ left: Number(b.getAttribute('data-cnc-rail-step')) * t.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Price slider on top of Dawn's two price boxes ---------- */
  function num(v) { var n = parseFloat(String(v || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }
  function fmt(n, cur) { return (cur || '$') + Math.round(n).toLocaleString('en-US'); }
  function enhancePrices(root) {
    $$('[data-cnc-price]', root).forEach(function (box) {
      if (box.__cnc) return;
      var inputs = box.querySelectorAll('input.field__input');
      if (inputs.length < 2) return;
      box.__cnc = true;
      var lo = inputs[0], hi = inputs[1];
      var max = Math.max(1, Number(box.getAttribute('data-max')) || num(hi.getAttribute('data-max')) || 10000);
      var cur = box.getAttribute('data-currency') || '$';
      var step = max > 5000 ? 50 : 10;
      var vMin = num(lo.value) || 0, vMax = num(hi.value) === null ? max : Math.min(max, num(hi.value));
      var ui = document.createElement('div');
      ui.className = 'cnc-price';
      ui.innerHTML =
        '<div class="cnc-price__vals"><span data-v="lo"></span><span data-v="hi"></span></div>' +
        '<div class="cnc-price__rng"><span class="cnc-price__track"></span><span class="cnc-price__fill"></span>' +
        '<input type="range" min="0" max="' + max + '" step="' + step + '" aria-label="Minimum price" data-r="lo" form="cnc-none">' +
        '<input type="range" min="0" max="' + max + '" step="' + step + '" aria-label="Maximum price" data-r="hi" form="cnc-none"></div>' +
        '<div class="cnc-price__pre"></div>';
      box.appendChild(ui);
      var rLo = ui.querySelector('[data-r="lo"]'), rHi = ui.querySelector('[data-r="hi"]'), fill = ui.querySelector('.cnc-price__fill');
      rLo.value = vMin; rHi.value = vMax;
      var presets = [[0, 1000], [1000, 2000], [2000, max]].filter(function (p) { return p[0] < max; });
      ui.querySelector('.cnc-price__pre').innerHTML = presets.map(function (p) {
        var label = p[0] === 0 ? 'Under ' + fmt(p[1], cur) : (p[1] >= max ? fmt(p[0], cur) + ' +' : fmt(p[0], cur) + ' – ' + fmt(p[1], cur).replace(cur, ''));
        return '<button type="button" data-p="' + p[0] + '-' + p[1] + '">' + label + '</button>';
      }).join('');
      function paint() {
        var a = Number(rLo.value), b = Number(rHi.value);
        ui.querySelector('[data-v="lo"]').textContent = fmt(a, cur);
        ui.querySelector('[data-v="hi"]').textContent = fmt(b, cur) + (b >= max ? '+' : '');
        fill.style.left = (a / max * 100) + '%';
        fill.style.right = (100 - b / max * 100) + '%';
      }
      function apply() {
        var a = Number(rLo.value), b = Number(rHi.value);
        lo.value = a > 0 ? a : '';
        hi.value = b < max ? b : '';
        // Dawn's facets.js listens for "input" on its form and refreshes the products
        (b < max ? hi : lo).dispatchEvent(new Event('input', { bubbles: true }));
      }
      [rLo, rHi].forEach(function (r) {
        r.addEventListener('input', function (e) {
          e.stopPropagation();
          if (Number(rLo.value) > Number(rHi.value) - step) {
            if (r === rLo) rLo.value = Number(rHi.value) - step; else rHi.value = Number(rLo.value) + step;
          }
          paint();
        });
        r.addEventListener('change', apply);
      });
      ui.addEventListener('click', function (e) {
        var b = e.target.closest('[data-p]');
        if (!b) return;
        var p = b.getAttribute('data-p').split('-');
        rLo.value = p[0]; rHi.value = p[1]; paint(); apply();
      });
      paint();
    });
  }

  /* ---------- Init + keep the bar in step with Dawn's AJAX filtering ---------- */
  function enhance(root) { syncBar(root); enhanceRails(root); enhancePrices(root); }
  function init(scope) {
    $$('[data-cnc-coll]', scope).forEach(function (root) {
      enhance(root);
      if (root.__cncObs || !('MutationObserver' in window)) return;
      var filters = $('#main-collection-filters', root);
      if (!filters) return;
      var queued = false;
      root.__cncObs = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; enhance(root); });
      });
      root.__cncObs.observe(filters, { childList: true, subtree: true });
    });
    stickyTop();
    onScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('popstate', function () { setTimeout(function () { init(); }, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
